module.exports = __webpack_public_path__ + "static/img/30011 (1).dd1d654.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30011 (1).webp
// module id = bvUa
// module chunks = 14